import type { NotificationInboxItem } from './notificationInboxTypes';

export const countUnreadNotifications = (items: NotificationInboxItem[]): number =>
  items.filter((item) => item.read_at === null).length;

export const partitionNotificationsByReadState = (
  items: NotificationInboxItem[],
): { unread: NotificationInboxItem[]; read: NotificationInboxItem[] } => ({
  unread: items.filter((item) => item.read_at === null),
  read: items.filter((item) => item.read_at !== null),
});
